import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-farewell-party',
  templateUrl: './farewell-party.component.html',
  styleUrls: ['./farewell-party.component.scss']
})
export class FarewellPartyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
